import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'lib-software-license',
  imports: [CommonModule, RouterModule],
  templateUrl: './software-license.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SoftwareLicenseComponent {}
